import {
  Box,
  Display,
  Flex,
  Heading,
  Image,
} from '@edreamsodigeo/prisma-design-system';
import React from 'react';

import {
  IMAGE_WIDTH,
  PAGE_BKG_COLOR,
  PAGE_MARGIN,
  PAGE_MAX_WIDTH,
  PAGE_MIN_HEIGHT,
  PAGE_TITLE_COLOR,
} from '../../utils';

export const PageErrorLayoutComponent = ({
  dataTestId,
  pageErrorTitle,
  pageErrorMessage,
  pageErrorButtons,
  pageErrorImageURL,
  pageErrorImageAlt,
}) => (
  <Box
    backgroundColor={PAGE_BKG_COLOR}
    minHeight={PAGE_MIN_HEIGHT}
    data-testid={dataTestId}
  >
    <Flex
      pt="3x_big"
      sx={{
        textAlign: 'center',
        maxWidth: PAGE_MAX_WIDTH,
        margin: PAGE_MARGIN,
      }}
      flexDirection="column"
    >
      <Flex gap="huge" flexDirection="column">
        <Flex gap="big" flexDirection="column" alignItems="center">
          <Flex gap="1x_small" flexDirection="column">
            <Display type="1" color={PAGE_TITLE_COLOR}>
              {pageErrorTitle}
            </Display>
            <Heading type="5">{pageErrorMessage}</Heading>
          </Flex>
          <Flex gap="1x_small" flexDirection="row">
            {pageErrorButtons}
          </Flex>
        </Flex>
        <Image
          src={pageErrorImageURL}
          alt={pageErrorImageAlt}
          sx={{
            width: IMAGE_WIDTH,
            margin: 'auto',
            display: 'block',
          }}
        />
      </Flex>
    </Flex>
  </Box>
);
